module.exports = __webpack_public_path__ + "static/img/kuang1.e486b44.png";